var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_36669",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 44,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 44C39.1503 44 49 34.1503 49 22C49 9.84974 39.1503 0 27 0C14.8497 0 5 9.84974 5 22C5 34.1503 14.8497 44 27 44ZM31.7209 46.2865C32.9209 46.0261 33.7523 45.8457 33.9251 46.1892C34.2648 46.8649 28.4128 54 27.5 54C26.5872 54 20.6744 46.8649 21.0142 46.1892C21.1869 45.8457 22.0184 46.0261 23.2183 46.2865C24.3784 46.5383 25.883 46.8649 27.4696 46.8649C29.0563 46.8649 30.5608 46.5383 31.7209 46.2865Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_36669)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 45,
    height: 54,
    fill: "url(#paint0_linear_0_36669)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 22,
    r: 19,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_36669",
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDriver);
export default __webpack_public_path__ + "static/media/pin_driver.e73ae783.svg";
export { ForwardRef as ReactComponent };